import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import styles from './Hidden.module.scss';
import { BRAND } from '../../constants/brand';

interface HiddenProps {
  className?: string;
}

const Hidden: FunctionComponent<HiddenProps> = ({ children, className }) => {
  const hiddenClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-hidden`,
    className,
    {
      [styles.hidden]: true,
    },
  );

  return <div className={hiddenClass}>{children}</div>;
};

export default Hidden;
